export default __webpack_public_path__ + "static/media/coding.3956e3cc.svg";